import styled from '@emotion/styled';
import React from 'react';
import { i18n, mediaQuery } from 'src/common';
import { PaymentMethods, Text } from 'src/components';
import config from 'src/config';
import { colors, footer } from 'src/theme';
import { Flex } from '../grid';

const FooterStyle = styled.div({
  backgroundColor: colors.background1,

  minHeight: `${footer.mobileHeight}px`,

  [mediaQuery('mobile')]: {
    minHeight: `${footer.height}px`,
  },
});

const FlexStyle = styled(Flex)({
  width: '88%',
  margin: '0 auto',
  paddingInline: '16px',
  paddingBlock: '64px',

  [mediaQuery('laptopL')]: {
    width: '1150px',
    margin: '0 auto',
    paddingInline: 0,
    paddingBlock: '40px'
  },
})

const LinkStyle = styled.a({
  cursor: 'pointer',

  '&:hover': {
    color: colors.text7
  },
})

export const Footer = () => (
  <FooterStyle>
    <FlexStyle vertical gap={22}>
      <PaymentMethods />
      <Flex vertical gap={10}>
        <Text type="tiny" bold color={colors.text7}>
          {i18n.t('layout.footer.footerText1')}
        </Text>
        <Text type="tiny" bold color={colors.text7}>
          {i18n.t('layout.footer.footerText2')}
        </Text>
        <LinkStyle href={`${config.REACT_APP_KOMPARE_HOME!}/informacije-o-koristenju-osobnih-podataka/`} target="_blank">
          <Text type="tiny" color={colors.text4}>
            {i18n.t('layout.footer.footerText3')}
          </Text>
        </LinkStyle>
        <Flex gap={8} align='center'>
          <Text type='large' color={colors.text7}>©</Text>
          <Text type="tiny" color={colors.text7} bold>kompare.hr</Text>
        </Flex>
      </Flex>
    </FlexStyle>
  </FooterStyle>
)
